import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface QasBatchStateChangedNotifyReviewerProps extends BaseTemplateProps {
  batchId: string
  batchLink: string
}

export const QasBatchStateChangedNotifyReviewer: TemplateDefinition<QasBatchStateChangedNotifyReviewerProps> =
  {
    renderParams: (props: QasBatchStateChangedNotifyReviewerProps) => ({
      messageKey: 'notificationsDomain.templates.qasBatchStateChangedNotifyReviewer',
      values: {
        batchId: props.batchId,
      },
    }),
    getLink: (props: QasBatchStateChangedNotifyReviewerProps): string => props?.batchLink || '',
  }
